import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function MayaAccount({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({
    verified_account: false,
  });

  // Yes/No options
  const MAYA_ACCOUNT_OPTIONS = ["Yes", "No"];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails(prev => ({ ...prev,
      [name]: value,
    }));

    // Clear error when user makes a selection
    if (isError[name]) {
      setIsError({
        ...isError,
        [name]: false,
      });
    }
  };

  const validateForm = () => {
    const errors = {
      verified_account: !primaryDetails.verified_account,
    };

    setIsError(errors);

    const hasErrors = Object.values(errors).some(error => error);
    if (hasErrors) {
      toast.error("Please select Yes or No", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const handleNext = () => {
    if (validateForm()) {
      if (primaryDetails.verified_account === "Yes") {
        navigation.go("maya-account-details"); // Change to your actual route
      } else {
        navigation.go("maya-kita-club"); // Change to your actual route
      }
    }
  };

  const handleBack = () => {
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">

          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">MAYA ACCOUNT</h4>
              <p className="form-desc">Please indicate if this merchant has a Maya Account</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                  {/* Yes/No Question */}
                  <Form.Group className="mb-5" controlId="verified_account">
                    <Form.Label className="form-label">
                      Has Maya Account? <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {MAYA_ACCOUNT_OPTIONS.map((option, index) => (
                        <div
                          key={`maya-account-${index}-${option}`}
                          className={`form-radio-item${primaryDetails.verified_account === option ? " selected" : ""}`}
                        >
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              name="verified_account"
                              value={option}
                              label={option}
                              onChange={handleInputChange}
                              checked={primaryDetails.verified_account === option}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {isError.verified_account && (
                      <div className="form-error">
                        Please select Yes or No
                      </div>
                    )}
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                    >
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>

        </Row>
      </Container>
    </div>
  );
}

export default MayaAccount;
